// TODO: window.onerror is working properly when "registering" it from here
/*
window.onerror = function (msg, url, line, col, error) {
// Note that col & error are new to the HTML 5 spec and may not be
// supported in every browser.  It worked for me in Chrome.
  var extra = !col ? '' : '\ncolumn: ' + col
  extra += !error ? '' : '\nerror: ' + error

// You can view the information in an alert to see things working like this:
  alert('Error!: ' + msg + '\nurl: ' + url + '\nline: ' + line + extra)

// TODO: Report this error via ajax so you can keep track
//       of what pages have JS issues

  var suppressErrorAlert = true
// If you return true, then error alerts (like in older versions of
// Internet Explorer) will be suppressed.
  return suppressErrorAlert
}
*/

// Vue-specific handler
const errorHandler = (err, vm, info) => {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.error(err)
  console.error(vm)
  console.error(info)
}

export default errorHandler



// WEBPACK FOOTER //
// ./src/logger/index.js